import { render, staticRenderFns } from "./GoodsForm1.vue?vue&type=template&id=69c4d065&scoped=true&"
import script from "./GoodsForm1.vue?vue&type=script&lang=js&"
export * from "./GoodsForm1.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm1.vue?vue&type=style&index=0&id=69c4d065&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c4d065",
  null
  
)

export default component.exports